import {Component, Input, OnInit} from '@angular/core';
import {ContractTypeDistinctModel} from '../../../models/warranties/contract-type-distinct.model';
import {HttpService} from '../../../services/http.service';
import {AgeFilter} from '../../../models/Report/ageFilter.modal';
import {AgeData} from '../../../models/Report/ageData.modal';

@Component({
  selector: 'app-dealer-age',
  templateUrl: './dealer-age.component.html',
  styleUrls: ['./dealer-age.component.scss']
})
export class DealerAgeComponent implements OnInit {

  filter: AgeFilter = new AgeFilter();
  ageList: AgeData[] = [];
  contractTypes: ContractTypeDistinctModel[] = [];
  range: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  age1to = 2;
  age1from = 0;
  age2to = 5;
  age2from = 2;
  age3to = 10;
  age3from = 5;
  datalength = 1;
  @Input() dealerName: any[] = [];

  constructor(private http: HttpService) {
  }

  ngOnInit(): void {
    this.fetchContractTypes();
    this.refreshList();

  }

  orderBy(field: string) {
    if (this.filter.orderBy === field) {
      if (this.filter.order === 'ASC') {
        this.filter.order = 'DESC';
      } else {
        this.filter.order = 'ASC';
      }
    }
    this.filter.orderBy = field;
    this.refreshList();
  }

  refreshList() {
    if (this.filter.dealerNumber === 'null') {
      this.filter.dealerNumber = null;
    }
    this.filter.pageSize = 99;
    this.http.getAgeReport(this.filter).subscribe((res: any) => {
      this.ageList = res;
      res.forEach((item, i) => {
        this.datalength = 1 + i;
      });
    });
  }


  exportAsXLSX() {
    this.filter.pageSize = 999;
    this.http.downloadAgeReport(this.filter);
  }

  amount(invoice: any): string {
    const amount = invoice.total;
    return amount ? `EUR ${amount}` : '---';
  }

  showDirectionImage(): string {
    if (this.filter.orderBy === 'ASC') {
      return 'assets/images/icon-sort-up.png';
    } else {
      return 'assets/images/icon-sort-down.png';
    }
  }

  fetchContractTypes() {
    this.http.fetchDistinctContractTypes().subscribe((res) => {
      this.contractTypes = res;

    });
  }

  clearFilter() {
    this.filter = new AgeFilter();
    this.refreshList();
  }

  changePage(count: number) {
    this.filter.page += count;
    this.refreshList();
  }

  selectAge() {
    this.filter.ageGroup1 = [this.age1from, this.age1to];
    this.filter.ageGroup2 = [this.age2from, this.age2to];
    this.filter.ageGroup3 = [this.age3from, this.age3to];
    this.refreshList();
  }
}
